import React from "react"
import { Ban, Calendar, CreditCard, GraduationCap, Key, Repeat, Users } from "lucide-react"

export function ClubSection() {
  return (
    <section id="club" className="py-8 md:py-16 px-4">
      <div className="container">
        <div className="text-center mb-6">
          <h2 className="text-xl sm:text-2xl md:text-4xl font-bold font-display mb-3">
            Todo lo que tu Club necesita en un solo lugar
          </h2>
          <div className="inline-block bg-[#EA580C] text-white rounded-full px-4 py-2 text-sm sm:text-base font-bold">
            ¡GRATIS PARA SIEMPRE! 🎉
          </div>
          <div className="mt-3 text-center bg-white/10 p-3 sm:p-4 rounded-lg">
            <p className="text-sm sm:text-base font-bold text-[#EA580C]">
              ¡Los primeros 100 clubes tendrán beneficios exclusivos para siempre!
            </p>
          </div>
        </div>
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          <div className="bg-white/80 backdrop-blur-sm p-3 rounded-2xl shadow-md border border-orange-100 hover:shadow-lg hover:-translate-y-0.5 transition-all">
            <Calendar className="h-7 w-7 text-[#EA580C] mb-2" />
            <h3 className="text-base font-bold mb-1 font-display">Reservas Agiles</h3>
            <p className="text-xs text-muted-foreground">
              Disponibilidad de espacios, grupos de entrenamiento, clases y torneos
            </p>
          </div>
          <div className="bg-white/80 backdrop-blur-sm p-3 rounded-2xl shadow-md border border-orange-100 hover:shadow-lg hover:-translate-y-0.5 transition-all">
            <Users className="h-7 w-7 text-[#EA580C] mb-2" />
            <h3 className="text-base font-bold mb-1 font-display">Buscamos jugadores</h3>
            <p className="text-xs text-muted-foreground">
              Busqueda automatica de jugadores y equipos para optimizar tus reservas!
            </p>
          </div>
          <div className="bg-white/80 backdrop-blur-sm p-3 rounded-2xl shadow-md border border-orange-100 hover:shadow-lg hover:-translate-y-0.5 transition-all">
            <GraduationCap className="h-7 w-7 text-[#EA580C] mb-2" />
            <h3 className="text-base font-bold mb-1 font-display">Gestión de Clases Grupales</h3>
            <p className="text-xs text-muted-foreground">
              Organiza clases grupales, tus entrenadores y clases privadas fácilmente
            </p>
          </div>
          <div className="bg-white/80 backdrop-blur-sm p-3 rounded-2xl shadow-md border border-orange-100 hover:shadow-lg hover:-translate-y-0.5 transition-all">
            <Repeat className="h-7 w-7 text-[#EA580C] mb-2" />
            <h3 className="text-base font-bold mb-1 font-display">Suscripciones</h3>
            <p className="text-xs text-muted-foreground">Cobros recurrentes y gestión de membresías automática</p>
          </div>
          <div className="bg-white/80 backdrop-blur-sm p-3 rounded-2xl shadow-md border border-orange-100 hover:shadow-lg hover:-translate-y-0.5 transition-all">
            <CreditCard className="h-7 w-7 text-[#EA580C] mb-2" />
            <h3 className="text-base font-bold mb-1 font-display">Múltiples Formas de Cobro</h3>
            <p className="text-xs text-muted-foreground">
              Acepta MercadoPago y/o Modo junto con efectivo para clientes leales
            </p>
          </div>
          <div className="bg-white/80 backdrop-blur-sm p-3 rounded-2xl shadow-md border border-orange-100 hover:shadow-lg hover:-translate-y-0.5 transition-all">
            <Ban className="h-7 w-7 text-[#EA580C] mb-2" />
            <h3 className="text-base font-bold mb-1 font-display">Promociones Personalizadas</h3>
            <p className="text-xs text-muted-foreground">
              Gestión automática de promociones para mantener a tus subscriptores
            </p>
          </div>
          <div className="bg-white/80 backdrop-blur-sm p-3 rounded-2xl shadow-md border border-orange-100 hover:shadow-lg hover:-translate-y-0.5 transition-all">
            <Key className="h-7 w-7 text-[#EA580C] mb-2" />
            <h3 className="text-base font-bold mb-1 font-display">Acceso Digital Automatizado</h3>
            <p className="text-xs text-muted-foreground">
              Sistema de acceso 100% digital automatizado a tus instalaciones
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
